import { LOCATION_CHANGE } from "react-router-redux";
import AuthData from "lib/authData";
import { hasAnalyticsConsent } from "./consent";

const emitPageView = (action: Record<string, any>) => {
  if (!hasAnalyticsConsent()) return;

  const authData = AuthData.get();
  return {
    hitType: "page_view",
    page: action.payload,
    currentUserRole: authData?.user?.role,
  };
};

const eventsMap = {
  [LOCATION_CHANGE]: emitPageView,
};

export default eventsMap;
